import React, { useEffect, useState } from "react";
// import { useTracker } from "meteor/react-meteor-data";
import {
  Container,
  Segment,
  Header,
  List,
  Grid,
  GridColumn,
  GridRow,
} from "semantic-ui-react";
 import { Layout } from "./Layout";

export const Dashboard = () => {
  // const cookies = new Cookies();
  const [showTour, setShowTour] = useState(false);
  //set up tour of page
  // const splashTourSteps = dashSplash;

  useEffect(() => {
    document.title = "Rōpū Whakatau";
  }, []);

  return <Layout />;
};
